import React, { useEffect, useState, useCallback } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getPagesList } from "../../Redux/Actions/pagesActions";
import { columnsPage } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";

const ListPages = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();

  const pagesState = useSelector((state) => state.pages);
  const pagesList = pagesState?.pages;
  const loading = pagesState?.loading;

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];  
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: searchQuery,
      };
      dispatch(getPagesList(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh pages list");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (pagesList?.total) {
      setPagination((prev) => ({
        ...prev,
        total: pagesList.total,
      }));
    }
  }, [pagesList]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
    fetchDetails(newPagination.current, newPagination.pageSize);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <TableComponent
      h3heading="Pages List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsPage(canEdit)}
      buttonhead2={canAdd ? "Add Page" : null}
      navigateTo2={canAdd ? "/pages/add" : null}
      dataSource={
        Array.isArray(pagesList?.data) ? pagesList.data : []
      }
      loading={loading}
      setState={setTempSearch}
      filterFunction={filterHandler}
    />
  );
};

export default ListPages;
